<template>
<section class="media-section" id="media">
    <div class="page-wrap media-banner reveal"><button class="play" data-open-media aria-label="تشغيل المادة"><i class="bi bi-play-fill"></i></button><div><h2>شاهد واستمع<br>إلى محتوى السنة</h2><p>إصدارات مرئية وصوتية وقنوات وإذاعات متخصصة</p><RouterLink class="cta cta-gold" to="/media/sahih-al-bukhari-audiobook-2">استعرض المحتوى</RouterLink></div><div class="media-art"><i class="bi bi-mic-fill"></i></div></div>
  </section>
</template>

